import { render, staticRenderFns } from "./StarBar.vue?vue&type=template&id=40b57d0b&scoped=true&"
import script from "./StarBar.vue?vue&type=script&lang=js&"
export * from "./StarBar.vue?vue&type=script&lang=js&"
import style0 from "./StarBar.vue?vue&type=style&index=0&id=40b57d0b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b57d0b",
  null
  
)

export default component.exports